export const LOGIN = "/login";
export const REGISTER = "/register";
export const FORGET_PASSWORD = "/forget-password";

export const HOMEPAGE = "/";
export const ADMIN_PLACE = "/admin-place";
export const ADMIN_LOCATION = "/admin-location";
export const ADMIN_CATEGORY = "/admin-category";


export const ALL = "*";
